import {
  Pie
} from 'vue-chartjs'

export default {
  name: "Home",
  extends: Pie,
  props: ["data", "type"],
  data: () => ({
    // subtitle: ["Acumuladas", "Preço Acumuladas", "Valor de apostas"],
    // value: [0, 0, 0, 0, 0, 0],

    chartData: {
      labels: [],
      datasets: [{
        data: [0, 0, 0],
        fill: false,
        backgroundColor: [
          // 'rgba(0, 70, 0, 0.3)', // Green 
          // 'rgba(255, 0, 0, 0.2)', // Red
          // 'rgba(75, 192, 192, 1)', // Green
          // 'rgba(54, 162, 235, 0.2)', // Blue
          // 'rgba(153, 102, 255, 0.2)', // Purple
        ],
        borderColor: [
          // 'rgba(0, 70, 0, 0.4)', // Green 
          // 'rgba(255, 99, 132, 0.3)', // Red
          // 'rgba(255, 206, 86, 1)', // Yellow
          // 'rgba(153, 102, 255, 1)',
        ],

      }]
    },
    options: {
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false
    }
  }),

  watch: {
    data(val) {
      // console.log("data", val)
      val && this.buildChart()
    },
  },

  methods: {
    async buildChart() {
      if (this.type == "betsResume") {
        // Labels
        this.chartData.labels = [
          this.$t('awarded'),
          "GGR",
        ];
        // Colors
        this.chartData.datasets[0].backgroundColor = [
          'rgba(249, 168, 37, 1)', // Yellow - awarded
          'rgba(255, 69, 0, 0.4)', // Orange Red 
        ];
        // BorderColors
        this.chartData.datasets[0].borderColor = [
          'rgba(193, 121, 0, 1)', // Yellow - awarded
          'rgba(255, 69, 0, 0.5)', // Orange Red
        ]
        // Apostas e Prêmiadas 
        this.chartData.datasets[0].data = [this.data.prize_value]
        // Calcula o valor do GGR
        this.chartData.datasets[0].data[1] = (Number(this.data.bet_value).toFixed(2) - Number(this.data.prize_value).toFixed(2)).toFixed(2)
        // Altera as cores de acordo com o valor do GGR - Vermelho para negatívo
        if (this.chartData.datasets[0].data[1] < 0) {
          this.chartData.datasets[0].backgroundColor[1] = 'rgba(175, 0, 0, 1)' // Red Strong
          this.chartData.datasets[0].borderColor[1] = 'rgba(175, 0, 0, 1)' // Red Strong
        }
        // Cores verdes para o GGR positívo
        else {
          this.chartData.datasets[0].backgroundColor[1] = 'rgba(46, 124, 49, 1)' // Green  Strong
          this.chartData.datasets[0].borderColor[1] = 'rgba(0, 79, 4, 1)' // Green  Strong
        }
      }
      //  Chart for Quantity bets 
      if (this.type == "quantityBet") {
        this.chartData.labels = [
          this.$t('AmountLostBets'),
          this.$t('amountAwarded'),
        ]

        this.chartData.datasets[0].backgroundColor = [
          'rgba(255, 99, 71, 0.5)', // Blue
          'rgba(173, 255, 47, 0.4)' // Yellow 
        ];
        this.chartData.datasets[0].borderColor = [
          'rgba(255, 99, 71, 0.6)', // Blue
          'rgba(173, 255, 47, 0.5)' // Yellow
        ]
        this.chartData.datasets[0].data = [this.data.loss_qtd + 2, this.data.prize_qtd,]

      }
      //  Chart for Quantity bets 
      if (this.type == "playersInactive") {
        this.chartData.labels = [
          this.$t('actives'),
          this.$t('inactives'),
        ]

        this.chartData.datasets[0].backgroundColor = [
          'rgba(0, 70, 0, 0.3)', // Green 
          'rgba(255, 0, 0, 0.2)', // Red 
        ];
        this.chartData.datasets[0].borderColor = [
          'rgba(0, 70, 0, 0.4)', // Green 
          'rgba(255, 99, 132, 0.3)', // Red
        ]
        this.chartData.datasets[0].data = [this.data.active, this.data.inactive]

      }

      if (this.type == "totalOnlineBalance") {
        this.chartData.labels = [
          this.$t('onlineBalance'),
          this.$t('bonusBalance'),
        ]

        this.chartData.datasets[0].backgroundColor = [
          'rgba(245, 124, 0)', // Orange
          'rgba(123, 31, 162)', // Purple 
        ];

        this.chartData.datasets[0].borderColor = [
          'rgba(0, 0, 0, 0.3)', // Transparent
          'rgba(0, 0, 0, 0.3)', // Transparent
        ]

        this.chartData.datasets[0].data = [this.data.online_balance, this.data.online_bonus_balance]
      }

      this.renderChart(this.chartData, this.options)
    },
  },
};